import * as React from "react";
import { ETLCodes } from "../locales";
import styled from "styled-components";

export interface IInformationCardProps {
  text: string;
  type?: "Information" | "Warning" | "Error";
}

const StyledImageInfo = styled.i`
  color: #1e90ff;
  size: 9px;
`;

const StyledImageWarning = styled.i`
  color: #f9994a;
  size: 9px;
`;

const StyledImageError = styled.i`
  color: #ff0000;
  size: 9px;
`;

export const InformationCard: React.FunctionComponent<IInformationCardProps> = ({ text, type = "Information" }) => {
  switch (type) {
    case "Information":
      return (
        <div style={{ marginLeft: "2rem" }}>
          <StyledImageInfo className="fas fa-info-circle"/>
          {` ${text}`}
        </div>
      );
    case "Warning":
      return (
        <div style={{ marginLeft: "2rem" }}>
          <StyledImageWarning className="fas fa-exclamation-triangle"/>
          {` ${text}`}
        </div>
      );
    case "Error":
      return (
        <div style={{ marginLeft: "2rem" }}>
          <StyledImageError className="fas fa-exclamation-circle"/>
          {` ${text}`}
        </div>
      );
    default:
      break;
  }
};
